import PlansService from '../../service/plans-service';
import displayNetworkError from '../../helpers/displayNetworkError';

export const makePlansActions = (set, get) => ({
    fetchPlans: async () => {
        set('plansLoading', true);
        set('plansError', null);
        try {
            const data = await PlansService.getPlansAsync();
            set('plans', data);
        } catch (error) {
            set('plansError', error);
            displayNetworkError(error);
        } finally {
            set('plansLoading', false);
        }
    },
});
